import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { InputBase, Stack, Typography } from '@lyearn/ui';
import SurveyBlockContainer from '@/modules/corporate/modules/survey/views/SurveyEditor/components/SurveyBlockContainer';

import { textareaStyles } from './styles';
import { SurveyWelcomeBlockEditorProps } from './types';

const CLASSES = { multiline: 'p-0', input: 'p-0 h-auto' };

function SurveyWelcomeBlockEditor(props: SurveyWelcomeBlockEditorProps) {
  const { t } = useTranslation();
  const { isSelected, error, survey, onClick, onChange } = props;

  const { onNameChange, onDescriptionChange } = useMemo(
    () => ({
      onNameChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        onChange({ name: event.target.value });
      },
      onDescriptionChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        onChange({ description: event.target.value });
      },
    }),
    [onChange],
  );

  return (
    <>
      <SurveyBlockContainer isSelected={isSelected} onSelect={onClick}>
        <Stack direction="col" gapY={10}>
          <InputBase
            multiline
            className={cn('heading-l text-text-primary', textareaStyles(3.6))}
            classes={CLASSES}
            placeholder={t('SurveyEditor:UntitledSurvey')}
            readOnly={!isSelected}
            value={survey.name || ''}
            onChange={onNameChange}
          />
          <InputBase
            multiline
            className={cn('body-short-01 text-text-secondary', textareaStyles(2.4))}
            classes={CLASSES}
            placeholder={t('SurveyEditor:DescriptionPlaceholder')}
            readOnly={!isSelected}
            value={survey.description || ''}
            onChange={onDescriptionChange}
          />
        </Stack>
      </SurveyBlockContainer>
      {error ? (
        <Typography
          className="m-8 mt-4"
          color="text-text-error"
          data-database-form-error={error.message}
          variant="body-short-02">
          {error.message}
        </Typography>
      ) : null}
    </>
  );
}

export default SurveyWelcomeBlockEditor;
